module.exports = __webpack_public_path__ + "img/se-redovisning.195f41d6.png";